import * as React from 'react';
import { Button } from 'antd';
import { RouteComponentProps, withRouter, Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux'; // Connecting to Redux
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from "src/core/Routes";
import { withLocalize, LocalizeContextProps, Translate } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';
import GuideSection from '../../components/public/GuideSection';
import "./Parents.less";

interface RouteProps {
    gradeId: string;
}

interface ParentsProps extends PageProps<RouteProps>, LocalizeContextProps {
}

class Parents extends React.Component<ParentsProps> {
    constructor(props: ParentsProps) {
        super(props);
        bindAllOfThis(this, Parents.prototype);
    }

    render() {
        return <div className="parents-portal">
            <h2><Translate id="public.parents.pageHeader" /></h2>
            <h2><Translate id={"public.parents.grade" + this.props.match.params.gradeId + ".overview.pageSubHeader"} /></h2>
            <GuideSection
                headerKey={"public.parents.grade" + this.props.match.params.gradeId + ".overview.bigQuestion.header"}
                bodyKey={"public.parents.grade" + this.props.match.params.gradeId + ".overview.bigQuestion.body"}
            />
            <GuideSection
                headerKey={"public.parents.grade" + this.props.match.params.gradeId + ".overview.bigAdventure.header"}
                bodyKey={"public.parents.grade" + this.props.match.params.gradeId + ".overview.bigAdventure.body"}
                {...console.warn("Grade ID: " + this.props.match.params.gradeId)}
            />
            <GuideSection
                headerKey={"public.parents.grade" + this.props.match.params.gradeId + ".overview.planetaryMissions.header"}
                bodyKey={"public.parents.grade" + this.props.match.params.gradeId + ".overview.planetaryMissions.body"}>
                <div>
                    <Link tabIndex={-1} to={Routes.getRoute(Routes.PARENTS_PLANET, this.props.match.params.gradeId, 'planet-r')}>
                        <Button tabIndex={0}><Translate id="public.parents.planetLinks.planet-r" /></Button>
                    </Link>
                </div>

                <br></br>
                <div>
                    <Link tabIndex={-1} to={Routes.getRoute(Routes.PARENTS_PLANET, this.props.match.params.gradeId, 'planet-i')}>
                        <Button tabIndex={0}><Translate id="public.parents.planetLinks.planet-i" /></Button>
                    </Link>
                </div>

                <br></br>
                <div>
                    <Link tabIndex={-1} to={Routes.getRoute(Routes.PARENTS_PLANET, this.props.match.params.gradeId, 'planet-a')}>
                        <Button tabIndex={0}><Translate id="public.parents.planetLinks.planet-a" /></Button>
                    </Link>
                </div>

                <br></br>
                <div>
                    <Link tabIndex={-1} to={Routes.getRoute(Routes.PARENTS_PLANET, this.props.match.params.gradeId, 'planet-s')}>
                        <Button tabIndex={0}><Translate id="public.parents.planetLinks.planet-s" /></Button>
                    </Link>
                </div>

                <br></br>
                <div>
                    <Link tabIndex={-1} to={Routes.getRoute(Routes.PARENTS_PLANET, this.props.match.params.gradeId, 'planet-e')}>
                        <Button tabIndex={0}><Translate id="public.parents.planetLinks.planet-e" /></Button>
                    </Link>
                </div>

                <br></br>
                <div>
                    <Link tabIndex={-1} to={Routes.getRoute(Routes.PARENTS_PLANET, this.props.match.params.gradeId, 'planet-c')}>
                        <Button tabIndex={0}><Translate id="public.parents.planetLinks.planet-c" /></Button>
                    </Link>
                </div>

            </GuideSection>
            <br></br>
            <Link tabIndex={-1} to={Routes.getRoute(Routes.PARENTS_OBJECTIVES, this.props.match.params.gradeId)}>
                <Button tabIndex={0}><Translate id={"public.parents.grade" + this.props.match.params.gradeId + ".overview.objectivesLink"} /></Button>
            </Link>
        </div>;
    }
}

export default withLocalize(Parents as any) as any;



// WEBPACK FOOTER //
// ./src/pages/public/Parents.tsx